"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingWrapper;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UILoadingOverlay = _interopRequireDefault(require("UIComponents/loading/UILoadingOverlay"));

var RequestState = _interopRequireWildcard(require("../constants/RequestState"));

var getIsRequestState = function getIsRequestState(currentRequestStatus, requestState, inclusive) {
  if (Array.isArray(currentRequestStatus)) {
    if (inclusive) {
      return currentRequestStatus.every(function (status) {
        return status === requestState;
      });
    } else {
      return currentRequestStatus.some(function (status) {
        return status === requestState;
      });
    }
  }

  return currentRequestStatus === requestState;
};

function LoadingWrapper(_ref) {
  var children = _ref.children,
      ErrorComponent = _ref.ErrorComponent,
      errorMessage = _ref.errorMessage,
      LoadingComponent = _ref.LoadingComponent,
      showOverlay = _ref.showOverlay,
      requestStatus = _ref.requestStatus,
      showLoadingOnUninitialized = _ref.showLoadingOnUninitialized;
  var isUnitialized = (0, _react.useMemo)(function () {
    return getIsRequestState(requestStatus, RequestState.UNINITIALIZED, true);
  }, [requestStatus]);
  var isLoading = (0, _react.useMemo)(function () {
    return getIsRequestState(requestStatus, RequestState.PENDING, false);
  }, [requestStatus]);
  var isSucceeded = (0, _react.useMemo)(function () {
    return getIsRequestState(requestStatus, RequestState.SUCCEEDED, true);
  }, [requestStatus]);
  var isError = (0, _react.useMemo)(function () {
    return getIsRequestState(requestStatus, RequestState.FAILED, false);
  }, [requestStatus]);

  if (isLoading || isUnitialized && showLoadingOnUninitialized) {
    if (LoadingComponent) {
      return _react.default.createElement(LoadingComponent, null);
    } else if (showOverlay) {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UILoadingOverlay.default, {
        contextual: true
      }), children);
    } else {
      return _react.default.createElement(_UILoadingSpinner.default, null);
    }
  }

  if (isSucceeded) {
    return children;
  }

  if (isError) {
    if (ErrorComponent) {
      return _react.default.createElement(ErrorComponent, null);
    } else {
      return _react.default.createElement(_UIAlert.default, {
        type: "danger"
      }, errorMessage || _react.default.createElement(_FormattedMessage.default, {
        message: "ecosystemMarketplaceCore.loadingWrapperDefaultError"
      }));
    }
  } else {
    return null;
  }
}

LoadingWrapper.propTypes = {
  children: _propTypes.default.node,
  ErrorComponent: _propTypes.default.elementType,
  errorMessage: _propTypes.default.node,
  LoadingComponent: _propTypes.default.elementType,
  showOverlay: _propTypes.default.bool,
  requestStatus: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]).isRequired,
  showLoadingOnUninitialized: _propTypes.default.bool
};
LoadingWrapper.defaultProps = {
  showOverlay: false,
  showLoadingOnUninitialized: true
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/LoadingWrapper.js
// module id = 412
// module chunks = 209 210 211 212